// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.activated-btn {
  background-color: #008fc7;
  color: #f2f2f2;
}

.deactivated-btn {
  color: #adb5bd;
}

table th, table td{
 text-align: center;
}

.spaceword{
  /* display: table-caption;
  padding: 10px; */
  width: 14% !important;
}
`, "",{"version":3,"sources":["webpack://./src/app/views/submitted-forms/submitted-forms.component.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;EACE;kBACgB;EAChB,qBAAqB;AACvB","sourcesContent":[".activated-btn {\r\n  background-color: #008fc7;\r\n  color: #f2f2f2;\r\n}\r\n\r\n.deactivated-btn {\r\n  color: #adb5bd;\r\n}\r\n\r\ntable th, table td{\r\n text-align: center;\r\n}\r\n\r\n.spaceword{\r\n  /* display: table-caption;\r\n  padding: 10px; */\r\n  width: 14% !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
